import { makeStyles } from "@mui/styles";
import { Card, CardContent, Typography, Grid, Button } from "@mui/material";
import EmailIcon from "@mui/icons-material/EmailRounded";
import { grey } from "@mui/material/colors";
import api from "components/settings/api";
import { toast, Bounce } from "react-toastify";
import CustomToastMessage from "../../common/CustomToastMessage";
import { useAuth } from "components/context/auth";

const useStyles = makeStyles((theme) => ({
  root: {
    width: 207,
    height: 300,
    backgroundColor: "#ffffff",
    boxShadow: "none",
    border: "1px solid rgba(0, 27, 17, 0.1)",
    borderRadius: 12,
  },
  avatarDiv: {
    display: "contents",
  },
  cardMargin: {
    marginBottom: theme.spacing(0.5),
  },
  cardHeader: {
    textAlign: "center",
    padding: "10px",
  },
  cardTitle: {
    fontFamily: "Poppins",
    fontWeight: 600,
    fontSize: 20,
    color: "#48647F",
    textAlign: "center",
    letterSpacing: 0.15,
    textTransform: "none",
  },
  cardSubtitle: {
    fontFamily: "Open Sans",
    fontWeight: 400,
    fontSize: 12,
    letterSpacing: 0.15,
  },
  cardCat: {
    fontFamily: "Open Sans",
    fontWeight: 700,
    fontSize: 16,
    color: "#001B11",
  },
  cardText: {
    color: "rgba(0, 27, 17, 0.7)",
    fontFamily: "Open Sans",
    margin: theme.spacing(1),
    fontSize: 16,
    fontWeight: 600,
  },
  cardFooter: {
    marginTop: theme.spacing(2),
    paddingTop: theme.spacing(2),
    color: "rgba(0, 27, 17, 0.7)",
    fontFamily: "Open Sans",
    fontSize: 14,
    fontWeight: 400,
  },
}));

const SendVerification = () => {
  const { user } = useAuth();

  const classes = useStyles();
  const sendNewEmail = async () => {
    const payload = {
      id: user.id,
      fullname: user.fullname,
      email: user.email,
    };
    try {
      await api.post("/api/v1/users/new/verify", payload);
      // Toast message function
      const notify = (message) =>
        toast.success(<CustomToastMessage message={message} />, {
          autoClose: 2000,
          closeButton: true,
          hideProgressBar: false,
          transition: Bounce,
          position: "bottom-center",
        });

      notify("Verification Email Sent");
    } catch (err) {
      throw new Error(err);
    }
  };
  return (
    <>
      <Button className="button button--dashboard_team">
        <Grid container direction="column">
          <Card className={classes.root}>
            <CardContent>
              <Grid container className={classes.cardMargin}>
                <Grid container justifyContent="center">
                  <Grid item xs={12} className={classes.avatarDiv}>
                    <EmailIcon style={{ color: grey[300], fontSize: 97 }} />
                  </Grid>
                  <Grid item xs={12} className={classes.cardHeader}>
                    <Typography
                      component="div"
                      variant="h5"
                      className={classes.cardTitle}
                    >
                      Please Verify Your Email To Create Teams
                      <Button component="div"
                        color="primary"
                        variant="contained"
                        sx={{
                          marginTop: "1rem",
                        }}
                        onClick={sendNewEmail}
                        aria-label="Resend email"
                      >
                        Resend email
                      </Button>
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Grid>
      </Button>
    </>
  );
};

export default SendVerification;